import { Image, ImageVariant } from '../../../common/components/Image';
import { Link } from 'react-router';
import { useMainSponsorQuery } from '@data/sponsors/useMainSponsorQuery';

function MainSponsorLogo() {
  const { data: mainSponsor, isLoading, error } = useMainSponsorQuery();

  if (isLoading) {
    return null;
  }

  if (error || !mainSponsor) {
    return null;
  }

  const mainSponsorLogoUrl = mainSponsor && (mainSponsor.assets?.[0]?.src || mainSponsor.logo);

  if (!mainSponsorLogoUrl) {
    return null;
  }

  return (
    <Link className="header__sponsor-link" to={mainSponsor.url} target={'_blank'}>
      <Image
        className="header__sponsor-image"
        src={mainSponsorLogoUrl}
        alt={mainSponsor.name}
        variant={ImageVariant.Contain}
      />
    </Link>
  );
}

export default MainSponsorLogo;
